import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnarchive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_20138",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_20138)",
		children: /* @__PURE__ */ _jsx("path", { d: "M5.3077 20.4999C4.80257 20.4999 4.375 20.3249 4.025 19.9749C3.675 19.6249 3.5 19.1973 3.5 18.6922V7.0769C3.5 6.86535 3.53045 6.674 3.59135 6.50285C3.65225 6.3317 3.73975 6.17048 3.85385 6.0192L5.17693 4.4346C5.29744 4.28332 5.44648 4.17307 5.62403 4.10385C5.80159 4.03462 5.99102 4 6.1923 4H17.8077C18.0089 4 18.1984 4.03141 18.3759 4.09423C18.5535 4.15704 18.7025 4.2705 18.823 4.4346L20.1269 6.0192C20.2474 6.17048 20.3397 6.3317 20.4038 6.50285C20.4679 6.674 20.5 6.86535 20.5 7.0769V18.6922C20.5 19.1973 20.325 19.6249 19.975 19.9749C19.625 20.3249 19.1974 20.4999 18.6923 20.4999H5.3077ZM5.39997 6.49995H18.6L17.75 5.49995H6.24997L5.39997 6.49995ZM4.99997 7.99993V18.6922C4.99997 18.7691 5.03202 18.8397 5.09612 18.9038C5.16024 18.9679 5.23077 18.9999 5.3077 18.9999H18.6923C18.7692 18.9999 18.8397 18.9679 18.9038 18.9038C18.9679 18.8397 19 18.7691 19 18.6922V7.99993H4.99997ZM11.25 17.596H12.75V13.146L14.6 14.996L15.6538 13.9422L12 10.2884L8.34615 13.9422L9.39998 14.996L11.25 13.146V17.596Z" })
	})]
});
export default SvgUnarchive;
